// UserClasses.js
import React, { useState, useEffect } from 'react';
import './UserClasses.css';
import ViewClassProgress from '../../Components/ViewClassProgress/ViewClassProgress';
import Footer from '../../Components/Footer/Footer';
import axiosInstance from '../../Config/axiosConfig';
import { useNavigate } from 'react-router-dom';

function UserClasses() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('inProgress');
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubscribedClasses = async () => {
      try {
        setLoading(true);
        const accessToken = localStorage.getItem('accessToken');
        const storedDeviceId = localStorage.getItem('deviceId');
        const storedUserIp = localStorage.getItem('userIp');

        const response = await axiosInstance.get('/Class/get-subscribed-classes/1', {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            UserDevice: storedDeviceId,
            UserIPAddress: storedUserIp,
          }
        });
        
        console.log('check subscription res', response.data)
        if (response.data?.code === 200) {
          const rawClasses = response.data.data?.classes || [];
          
          const transformedClasses = rawClasses.map(cls => {
                const watchTime = cls.watch_time || 0;
                const duration = cls.duration || 0;
                const progress = duration > 0 ? Math.min(100, Math.floor((watchTime / duration) * 100)) : 0;

                return {
                  id: cls.id,
                  title: cls.title,
                  description: cls.description,
                  instructor: cls.instructor,
                  instructor_title: cls.instructor_title,
                  about_teacher: cls.about_teacher,
                  lessonCount: Array.isArray(cls.videos) ? cls.videos.length : 0,
                  duration: cls.duration, // keep in seconds for formatting inside ViewClassProgress
                  progress,
                  imageUrl: cls.thumbnail ? `data:image/jpeg;base64,${cls.thumbnail}` : null,
                  cost: cls.cost,
                  enrolled: cls.enrolled,
                  views: cls.views,
                  resource: cls.resource,
                  education_class: cls.education_class,
                };
              });

          setClasses(transformedClasses);
        } else {
          throw new Error(response.data?.message || 'Failed to fetch classes');
        }
      } catch (error) {
        console.error('Error fetching subscribed classes:', error);
        setError(error.response?.data?.message || error.message || 'Failed to load classes');
      } finally {
        setLoading(false);
      }
    };

    fetchSubscribedClasses();
  }, []);

  const inProgressClasses = classes.filter(cls => cls.progress < 100);
  const completedClasses = classes.filter(cls => cls.progress === 100);

  const classesToDisplay = activeTab === 'inProgress' ? inProgressClasses : completedClasses;

  return (
    <div className='user-classes-container'>
      <div className='user-classes-content'>
        <h1 className='user-classes-title'>My Classes</h1>

        {/* Tabs */}
        <div className='user-classes-tabs'>
          <button
            type="button"
            className={`user-classes-tab ${activeTab === 'inProgress' ? 'active' : ''}`}
            onClick={() => setActiveTab('inProgress')}
          >
            In Progress ({inProgressClasses.length})
          </button>
          <button
            type="button"
            className={`user-classes-tab ${activeTab === 'completed' ? 'active' : ''}`}
            onClick={() => setActiveTab('completed')}
          >
            Completed ({completedClasses.length})
          </button>
        </div>

        {/* Content */}
        {loading ? (
          <div className="user-classes-status">Loading your classes...</div>
        ) : error ? (
          <div className="user-classes-status error">Error: {error}</div>
        ) : classes.length === 0 ? (
          <div className="user-classes-status empty">
            <p>You haven't subscribed to any classes yet.</p>
            <button 
              onClick={() => navigate('/courses')}
              className="browse-button"
            >
              Browse Classes
            </button>
          </div>
        ) : (
          <div className='user-classes-list'>
          {classesToDisplay.map((cls) => (
              <ViewClassProgress 
                key={cls.id}
                classData={cls}
              />
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default UserClasses;